import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsStandUpPaddlingNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M13 7.25h-3V6h3zM10 9.25h3V8h-3zM12 11.25h-1V10h1z" />
        <path d="M11.266.044a.7.7 0 01.468 0c.241.085 1.072.445 1.838 1.543C14.337 2.683 15 4.465 15 7.329c0 4.94-1.94 7.93-2.24 8.362a.72.72 0 01-.592.309h-1.336a.72.72 0 01-.593-.31C9.94 15.259 8 12.27 8 7.33c0-2.865.663-4.647 1.428-5.743C10.194.489 11.025.129 11.266.044zm.234 1.264c-.23.125-.64.41-1.046.994-.588.841-1.204 2.357-1.204 5.027 0 4.026 1.381 6.628 1.868 7.42h.764c.487-.792 1.868-3.395 1.868-7.42 0-2.67-.617-4.186-1.204-5.027-.407-.584-.817-.869-1.046-.994zM2.007 14.304a2.274 2.274 0 001.539.01c.498-.172.758-.595.88-.933l.303-.83a3.958 3.958 0 00-.133-3.026l-.106-.228 2.68-7.365.627.228.428-1.174L5.797.102 5.37 1.277l.626.228-2.683 7.372-.218.102a3.958 3.958 0 00-2.047 2.233l-.302.83c-.122.337-.195.828.075 1.281.198.331.562.754 1.186.981zm1.128-1.17c-.172.06-.417.099-.7-.004a1.025 1.025 0 01-.54-.448c-.002-.002-.008-.013-.009-.047a.5.5 0 01.035-.166l.302-.83a2.708 2.708 0 011.29-1.473c.257.623.273 1.322.041 1.958l-.302.83a.5.5 0 01-.08.149c-.022.026-.035.03-.037.03z" />
      </g>
    </svg>
  )
);
SvgSportsStandUpPaddlingNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsStandUpPaddlingNormalXsmall;
